import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "inputRow" }
const _hoisted_4 = { class: "flex flex-wrap" }
const _hoisted_5 = { class: "inputField flex w-1/3" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = { class: "inputField flex w-1/3" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = { class: "inputField flex w-1/3" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "inputGroup" }
const _hoisted_12 = { class: "groupTitle" }
const _hoisted_13 = { class: "inputGroup" }
const _hoisted_14 = { class: "groupTitle" }
const _hoisted_15 = { class: "inputGroup" }
const _hoisted_16 = { class: "groupTitle" }
const _hoisted_17 = { class: "inputGroup" }
const _hoisted_18 = { class: "groupTitle" }
const _hoisted_19 = { class: "inputGroup" }
const _hoisted_20 = { class: "groupTitle" }
const _hoisted_21 = { class: "inputGroup" }
const _hoisted_22 = { class: "groupTitle" }
const _hoisted_23 = { class: "inputGroup" }
const _hoisted_24 = { class: "groupTitle" }
const _hoisted_25 = { class: "inputGroup" }
const _hoisted_26 = { class: "groupTitle" }

import FilterService from "@/utilities/services/FilterService";
import { TableType } from "@/utilities/enums/Enums";
import { computed, onMounted } from "vue";
import { useGlobalStore } from "@/stores/GlobalStore";



export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationFilterPopup',
  setup(__props) {

const globalStore = useGlobalStore();

const userFilters = computed(()=>{
  return globalStore.userPreferences.userFilters;
});
const userHiddenColumns = computed(()=>{
  return globalStore.userPreferences.userHiddenColumns;
});

const tmpUserFilters = computed(()=>{
  return globalStore.tmpPreferences.tmpUserFilters;
});
const tmpUserHiddenColumns = computed(()=>{
  return globalStore.tmpPreferences.tmpUserHiddenColumns;
});

onMounted(()=>{
  //init tmp values
  globalStore.setTmpFilters(userFilters.value.filter(f => f.tableName === TableType[TableType.register]));
  globalStore.setTmpHiddenColumns(userHiddenColumns.value.filter(f => f.tableName === TableType[TableType.register]));

  // init afterFilters count
  globalStore.setCountAfterFilters(globalStore.gridStore?.count);
});

// init checkboxes according to tmpFilters [attributeValue == input-id]
const isFiltered = (attName, attVal) => {
  return tmpUserFilters.value.some(tuf => tuf.attributeName === attName && tuf.attributeValue === attVal.toString());
};

// init visibility buttons according to tmpHiddenColumns
const isHidden = (attName) => {
  return tmpUserHiddenColumns.value.some(thc => thc.attributeName === attName.toString());
};

const filterChanged = ({ target }, propName) => {
  if(target.checked) {
    // add to tmpFilterList
    globalStore.addUserFilter({tableName: TableType[TableType.register], attributeName: propName, attributeValue: target.value.toString()});
  }
  else {
    // remove from tmpFilterList
    tmpUserFilters.value.forEach((tuf,index)=>{
      if(tuf.attributeName === propName && tuf.attributeValue === target.value.toString()) tmpUserFilters.value.splice(index, 1);
    });

    globalStore.setTmpFilters(tmpUserFilters.value);
  }

  calculateRestEntities();
};

const visibilityChange = (colName) => {
  if(!tmpUserHiddenColumns.value.some(thc => thc.attributeName === colName)) {
    // add to tmpHiddenColumnList
    globalStore.addUserHiddenColumn({ tableName: TableType[TableType.register], attributeName: colName, attributeValue: "" });
  }
  else {
    // remove from tmpHiddenColumnList
    tmpUserHiddenColumns.value.forEach((thc,index)=>{
      if(thc.attributeName === colName) tmpUserHiddenColumns.value.splice(index, 1);
    });

    globalStore.setTmpHiddenColumns(tmpUserHiddenColumns.value);
  }

  calculateRestEntities();
};

const calculateRestEntities = () => {
  const allRecords = globalStore.gridStore.storage.allValues;
  const tmpFilterMethod = FilterService.buildFilter(TableType[TableType.register], true);

  let counter = 0;

  allRecords.forEach(r => {
    if (tmpFilterMethod(r)) counter++;
  });

  globalStore.setCountAfterFilters(counter);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('popups.registerFilter.status')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                checked: isFiltered('isActive', 'Active'),
                type: "checkbox",
                id: "Active",
                value: "Active",
                onChange: _cache[0] || (_cache[0] = (e) => filterChanged(e, 'isActive'))
              }, null, 40, _hoisted_6),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "inputTitle ml-2" }, [
                _createElementVNode("label", null, "aktiv")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                checked: isFiltered('isActive', 'Inactive'),
                type: "checkbox",
                id: "Inactive",
                value: "Inactive",
                onChange: _cache[1] || (_cache[1] = (e) => filterChanged(e, 'isActive'))
              }, null, 40, _hoisted_8),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "inputTitle ml-2" }, [
                _createElementVNode("label", null, "inaktiv")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                checked: isFiltered('isToday', 'Today'),
                type: "checkbox",
                id: "Today",
                value: "Today",
                onChange: _cache[2] || (_cache[2] = (e) => filterChanged(e, 'isToday'))
              }, null, 40, _hoisted_10),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "inputTitle ml-2" }, [
                _createElementVNode("label", null, "nur heute")
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.lastName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('lastName') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (visibilityChange('lastName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.firstName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('firstName') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (visibilityChange('firstName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.kid')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('kid') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (visibilityChange('kid')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.email')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('email') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (visibilityChange('email')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.phoneNumber')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('phoneNumber') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (visibilityChange('phoneNumber')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.company')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('companyName') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (visibilityChange('companyName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.location')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('lastLocationName') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (visibilityChange('lastLocationName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.registerFilter.guestCount')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('lastGuestCount') ? 'icon-spalte-ausblenden text-red text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (visibilityChange('lastGuestCount')))
        }, null, 2)
      ])
    ])
  ]))
}
}

})